module.exports = __webpack_public_path__ + "static/media/scanNotify.8738e483.svg";